import swipeConstants from 'areas/swipes/constants';
import authConstants from 'areas/auth/constants';

const sort = swipes => swipes.sort((a, b) => a.swipeTime > b.swipeTime ? 1 : a.swipeTime < b.swipeTime ? -1 : 0);

const concat = (swipes, swipe) => (swipes || []).concat(swipe);

const limit = (swipes, limit) => swipes.filter((s, i) => i < limit);

const manageSwipes = (swipes, swipe) => limit(sort(concat(swipes, swipe)), 100);

const initial = {
    submitting: false,
    swipes: [],
    currentSwipeContext: '',
    uiState: {
        timeFromWork: [0, 0],
        timeToWork: [0, 0],
        selectedEmployer: '',
        selectedJobRole: ''
    }
};

export function swipes(state = initial, action) {
    switch (action.type) {
        case authConstants.SIGN_OUT_SUCCESS:
            return {
                ...initial
            };
        case swipeConstants.SET_CURRENT_SWIPE_CONTEXT:
            return {
                ...state,
                currentSwipeContext: action.context
            };
        case swipeConstants.UPLOAD_SWIPE_REQUESTED:
            return {
                ...state,
                submitting: true
            };
        case swipeConstants.UPLOAD_SWIPE_SUCCESS:
            return {
                ...state,
                submitting: false,
                swipes: manageSwipes(state.swipes, action.swipe)
            };
        case swipeConstants.UPLOAD_SWIPE_FAILURE:
            return {
                ...state,
                submitting: false
            };
        case swipeConstants.CLEAR_SWIPES:
            return {
                ...state,
                swipes: [],
                submitting: false
            };
        case swipeConstants.STORE_SWIPE_UI_STATE:
            return {
                ...state,
                uiState: {
                    timeToWork: action.timeToWork,
                    timeFromWork: action.timeFromWork,
                    selectedEmployer: action.selectedEmployer,
                    selectedJobRole: action.selectedJobRole
                }
            };
        case swipeConstants.RESET_SWIPE_UI_STATE:
            return {
                ...state,
                uiState: {
                    timeToWork: [0, 0],
                    timeFromWork: [0, 0],
                    selectedEmployer: '',
                    selectedJobRole: ''
                }
            };
        default:
            return state;
    }
}